import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/img/groupMark.png';
const _withScopeId = n => (_pushScopeId("data-v-329b3d78"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "您可进入以下企业", -1));
const _hoisted_2 = { class: "introduce" };
const _hoisted_3 = { class: "phone-style" };
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" 已在以下企业或组织绑定了账号，您可进入以下任一企业或组织 ");
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    }),
    /*#__PURE__*/ _createElementVNode("span", null, "英博")
], -1));
const _hoisted_7 = { class: "company-name" };
const _hoisted_8 = { class: "user-info" };
const _hoisted_9 = { class: "user-name" };
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'AccountList',
    props: {
        account: { default: () => [] },
        phone: { default: "" }
    },
    emits: ["clickHandle"],
    setup(__props, { emit }) {
        const props = __props;
        const phoneNum = computed(() => props.phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2"));
        const clickHandle = (data) => {
            emit("clickHandle", data);
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _hoisted_1,
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, "+86-" + _toDisplayString(_unref(phoneNum)), 1),
                        _hoisted_4
                    ])
                ]),
                _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.account, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: item.user_id,
                            class: "item-style",
                            onClick: ($event) => (clickHandle(item))
                        }, [
                            _hoisted_6,
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(item.company_name), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.user_name), 1),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["type", item.type === 'master' ? 'master-style' : 'sub-style'])
                                    }, [
                                        _createVNode(_component_svg_icon, {
                                            "icon-class": "confirm",
                                            "class-name": "confirm-icon"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(item.type === "master" ? "主账号" : "子账号"), 1)
                                    ], 2)
                                ])
                            ])
                        ], 8, _hoisted_5));
                    }), 128))
                ])
            ], 64));
        };
    }
});
